import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "./Slider.css";

export const CategorySlider = ({ category }) => {
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState([]);

  useEffect(() => {
    if (category && category.length > 0) {
      const updatedLoadingStates = category.map(() => true);
      setLoadingStates(updatedLoadingStates);

      category.forEach((item, index) => {
        const img = new Image();
        img.src = item.imgUrl;

        if (img.complete) {
          handleImageLoad(index);
        }
      });
    }
  }, [category]);

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  const breakpoints = {
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    300: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1}
      breakpoints={breakpoints}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      loop={true}
      className="category-slider"
    >
      {category &&
        category.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div
              className="category-box-h3"
              onClick={() => navigate(`/view-category/${item.id}`)}
            >
              <div className="category-box">
                {loadingStates[index] ? (
                  <p className="skeleton-loader-category">ছবি লোড হচ্ছে...</p>
                ) : null}
                <img
                  src={item.imgUrl}
                  alt={item.name}
                  onLoad={() => handleImageLoad(index)}
                  style={{ display: loadingStates[index] ? "none" : "block" }}
                />
              </div>
              <h3>{item.name}</h3>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export const HeroSlider = ({ heroSlices }) => {
  const [loadingStates, setLoadingStates] = useState([]);

  useEffect(() => {
    if (heroSlices && heroSlices.length > 0) {
      setLoadingStates(Array(heroSlices.length).fill(true));

      heroSlices.forEach((item, index) => {
        const img = new Image();
        img.src = item.image;

        if (img.complete) {
          handleImageLoad(index);
        }
      });
    }
  }, [heroSlices]);

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      slidesPerView={1}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      className="hero-slider"
    >
      {heroSlices &&
        heroSlices.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div className="hero-slider-container">
              {loadingStates[index] ? (
                <p className="skeleton-loader-hero">ছবি লোড হচ্ছে...</p>
              ) : null}
              <Link to={item.url}>
                <img
                  src={item.image}
                  alt="hero-image"
                  onLoad={() => handleImageLoad(index)}
                  style={{ display: loadingStates[index] ? "none" : "block" }}
                />
              </Link>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export const ProductSlider = ({ data }) => {
  return (
    <Swiper
      pagination={{ clickable: true }}
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
    >
      {data &&
        data?.map((item) => {
          if (item.url) {
            return (
              <SwiperSlide key={item.id}>
                <img src={item.url} alt="productimage" />
              </SwiperSlide>
            );
          }
        })}
    </Swiper>
  );
};

export const ProductCategorySlider = ({ data }) => {
  const navigate = useNavigate();

  const breakpoints = {
    350: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    300: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  };

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      breakpoints={breakpoints}
      autoplay={{ delay: 500, disableOnInteraction: false }}
      loop={true}
      // modules={[Navigation, Pagination, Autoplay]}
      // slidesPerView={1}
      // breakpoints={breakpoints}
      // autoplay={{ delay: 2000, disableOnInteraction: false }}
      // loop={true}
      className="category-slider"
    >
      {data &&
        data.map((item, index) => {
          return (
            <SwiperSlide>
              <div
                className="category-box-h3"
                key={index}
                onClick={() => navigate(`/view-category/${item.id}`)}
              >
                <div className="category-box">
                  <img src={item.imgUrl} alt="category" />
                </div>
                <h3>{item.name}</h3>
              </div>
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};
